import {cardImages} from '../../assets/ImageIndex'

interface ElementType {
  type: string ;
  content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
  getStyles?: (breakpoints: {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }) => React.CSSProperties;
}

const titleA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  textAlign: 'center',
  flexDirection: 'column',
  color: '#333',
  fontWeight: 'bold', 
  fontSize: isMobileMini ? '15px': isMobileMedium ? '17px': isMobileBig ? '18px': isMiniNotebook ? '20px' : '25px',
});

const brA = (isDesktopOrLaptop: boolean) => ({
  height: '8px',
});
const brB = (isDesktopOrLaptop: boolean) => ({
  height: '5px',
});
const brC = (isDesktopOrLaptop: boolean) => ({
  height: '3px',
});


const textA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  width: isMobileMini ? '310px': isMobileMedium ? '460px': isMobileBig ? '570px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const textB = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const divA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': isMobileMini ? 'column': isMobileMedium ? 'column': isMobileBig ? 'column': isMiniNotebook ? 'row' : 'row', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const listA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
    color: '#333',
    fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
    gap: isMobileMini ? '8px': isMobileMedium ? '10px': isMobileBig ? '15px': isMiniNotebook ? '18px' : '18px',
    textAlign: 'justify',
    width: isMobileMini ? '290px': isMobileMedium ? '440px': isMobileBig ? '550px': isMiniNotebook ? '680x' : '880px',
})

const imageA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '290px': isMobileMedium ? '420px': isMobileBig ? '450px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '450px' : '500px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px'
})

export const card_15_01_25 = {

  date: '15-01-2025',
  routeCard: '/nutricao/beneficios-do-cha-de-gengibre/15-01-2025',
  description: 'Benefícios do chá de gengibre. Saiba como ele melhorar seu sistema imunológico.',
  month: 'Janeiro',
  shortTitle: 'Gengibre: Um aliado em defesa do sistema imunológico',
  elements: [
    {
      type: 'title',
      content: 'Benefícios do chá de Gengibre',
      getStyles: titleA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">O Gengibre, ou Zingiber Officinale, é uma especiaria originária da ilha de Java e atualmente é plantada em todas as regiões tropicais. 
          A parte da planta que é consumida é o seu caule subterrâneo. De sabor picante, 
          o gengibre pode ser usado tanto em pratos salgados quanto nos doces e pode ser encontrado em conserva ou cristalizado. 
          O gengibre seco é mais aromático e tem sabor mais suave.
          Ele possui propriedades antioxidantes e anti-flamatórias graças às substâncias chogaol, gingerol e zingerona. 
          Tambem é um ótimo aliado na redução de peso por se tratar de um alimento termogênico.
          Existem estudos que comprovam a eficácia no combate a azia, gazes e má digestão, alem de aliviar cólicas menstruais.
          </p>
          `,
          getStyles: textA,
        },
        {
          type: 'image',
          content: cardImages.Gengibreplanta_15_01_25,
          getStyles: imageA,
        },
      ],
      getStyles: divA,
    },
    {
      type: 'title',
      content: 'Vamos emagrecer com chá de Gengibre?',
      getStyles: titleA,
    },
    {
      type: 'div',
      content: [

        {
          type: 'title',
          content: 'Vamos emagrecer com chá de Gengibre?',
          getStyles: titleA,
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'image',
          content: cardImages.emagrece_15_01_25,
          getStyles: imageA,
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">A melhor forma de emagrecer com o chá de Gengibre é tomar 4 xícaras dele ao longo do dia,
           intercalando com a ingestão de uma porção de fruta.
          No verão tem a opção de bebê-lo gelado ou em drinks.
          </p>
          `,
          getStyles: imageA,
        },
      ],
      getStyles: divA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'title',
      content: 'Principais nutrientes do Gengibre: ',
      getStyles: titleA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'div',
      content: [
        {
          type: 'list',
          content: [
            'Vitaminas: Vitamina C, vitamina B6, B12, Vitamina D .',
           'Minerais: Ferro, Magnésio e Cálcio.',
           'Compostos Bioativos: Gingerol, chogal e zingerona',
          ],
          getStyles: listA,
        }
      ],
      getStyles: divA
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'div',
      content: [
        {
          type: 'image',
          content: cardImages.GengibreCha_15_01_25,
          getStyles: imageA,
        },
        {
          type: 'text',
          content: 
          `<br></br>
          <p style="text-indent: 20px;">O gengibre é conhecido como a planta da digestão na Ásia,
           de sabor picante e forte, ela tem forte presença na culinária, nos mais diversos pratos, dos salgados aos doces.
           Ainda assim a ingestão através de bebidas e chás é o mais comum, o chá de gengibre é conhecido por ser termogênico e alivia mal estar estomacal.
          </p>
          <br></br>
          `,
          getStyles: textA,
        },
      ],
      getStyles: divA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'title',
      content: 'Como preparar o chá',
      getStyles: titleA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'div',
      content: [
        {
          type: 'list',
          content: [
            'Separar todos os igredientes numa panela: 2cm de gengibre, 1 colher de sopa de gengibre em pó, 500ml a 1litro de água.',
           'Levar ao fogo médio e deixar ferver por cerca de 10 a 12 minutos.',
           'Desligar o fogo, tapar a panela e esperar amornar.',
           'Coar e beber.',
           'Se desejar, adicione mel'
          ],
          getStyles: listA,
        }
      ],
      getStyles: divA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brB,
    },
  ] as ElementType[],
  tags: ['nutrição', 'chá', 'gengibre'],
  author: 'John Doe',
}


